import React, { forwardRef } from 'react'
import styled from 'styled-components'

export const UserAvatar = forwardRef(({ avatar, onClick }, ref) => {
  return (
    <StyledImage
      src={avatar}
      alt="Avatar"
      onClick={onClick}
      ref={ref}
    />
  )
})

const StyledImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer
`
